"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StereoCameraObject = void 0;
const tslib_1 = require("tslib");
const CameraObject_1 = require("./CameraObject");
const core_1 = require("@openhps/core");
const PerspectiveCameraObject_1 = require("./PerspectiveCameraObject");
let StereoCameraObject = class StereoCameraObject extends CameraObject_1.CameraObject {
    constructor(uid, displayName, left, right) {
        super(uid, displayName);
        /**
         * Camera eye separation
         * @default 0.064
         */
        this.eyeSep = 0.064;
        this.cameraL = left;
        this.cameraR = right;
        if (left !== undefined && right !== undefined) {
            this.uid = left.uid + right.uid;
        }
    }
};
exports.StereoCameraObject = StereoCameraObject;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", PerspectiveCameraObject_1.PerspectiveCameraObject)
], StereoCameraObject.prototype, "cameraL", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", PerspectiveCameraObject_1.PerspectiveCameraObject)
], StereoCameraObject.prototype, "cameraR", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Object)
], StereoCameraObject.prototype, "eyeSep", void 0);
exports.StereoCameraObject = StereoCameraObject = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [String, String, PerspectiveCameraObject_1.PerspectiveCameraObject, PerspectiveCameraObject_1.PerspectiveCameraObject])
], StereoCameraObject);
//# sourceMappingURL=StereoCameraObject.js.map